// HOOKS
import { createContext, useEffect } from "react";
import useGetManyAssets from "../../hooks/assets/useGetMany.asset";
import useUpdateAsset from "../../hooks/assets/useUpdate.asset";
import useCreateAsset from "../../hooks/assets/useCreate.asset";
import useCreateManyAssets from "../../hooks/assets/useCreateMany.asset";
import useDeleteManyAssets from "../../hooks/assets/useDeleteMany.asset";

export const AssetsContext = createContext({
  assets: [],
  setAssets: () => {},
  getAssets: () => {},
  metaData: {},
  setMetaData: () => {},
  assetInput: {},
  setAssetInput: () => {},
  query: {},
  setQuery: () => {},
  handleLimitChange: () => {},
  handlePageChange: () => {},
  handleSearch: () => {},
  handleSort: () => {},
  isLoading: false,
  error: null,
  updateAsset: () => {},
  createAsset: () => {},
  createManyAssets: () => {},
  deleteManyAssets: () => {},
  handleChange: () => {},
});

export const AssetsProvider = ({ children }) => {
  const { updateAsset } = useUpdateAsset();
  const { createAsset } = useCreateAsset();
  const { createManyAssets } = useCreateManyAssets();
  const { deleteManyAssets } = useDeleteManyAssets();
  const {
    assets,
    setAssets,
    getAssets,
    metaData,
    setMetaData,
    assetInput,
    setAssetInput,
    setQuery,
    query,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    loading: isLoading,
    error,
  } = useGetManyAssets();

  const handleChange = async (event) => {
    try {
      const { name, value, dataset } = event.target;
      const { id } = dataset;
      const updatedAsset = assets?.find((asset) => asset._id === id);
      // Update asset in state
      setAssets(
        assets.map((asset) =>
          asset._id === id ? { ...asset, [name]: value } : asset
        )
      );
      // Update asset in DB
      const res = await updateAsset({ ...updatedAsset, [name]: value });
    } catch (error) {
      console.log("Error in handleChange", error);
    }
  };

  return (
    <AssetsContext.Provider
      value={{
        assets,
        setAssets,
        getAssets,
        metaData,
        setMetaData,
        assetInput,
        setAssetInput,
        setQuery,
        query,
        handleLimitChange,
        handlePageChange,
        handleChange,
        handleSearch,
        handleSort,
        isLoading,
        error,
        updateAsset,
        createAsset,
        createManyAssets,
        deleteManyAssets,
      }}
    >
      {children}
    </AssetsContext.Provider>
  );
};
